import { jsx as _jsx } from "react/jsx-runtime";
import { forwardRef } from 'react';
import { Dialog as HeadlessDialog } from '@flywire/react-headlessui';
import { cx } from '../../utils';
export const useTitleClasses = ({ className }) => {
    return cx('text-2xl font-normal leading-6 text-gray-950', className);
};
const TitleComponent = forwardRef(({ className, ...rest }, ref) => {
    const classes = useTitleClasses({ className });
    return _jsx(HeadlessDialog.Title, { className: classes, ref: ref, ...rest });
});
TitleComponent.displayName = 'Title';
const Title = TitleComponent;
export { Title };
//# sourceMappingURL=Title.js.map